import styled from "styled-components";
import AntInput from "uiKits/Input";
import { Form } from "antd";
import AntButton from "uiKits/Button";
import { media } from "@/theme/breakpoints";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";

export const StyledInput = styled(AntInput)`
  background: #fff;
  height: 42px;
  min-height: 44px;
`;

const dropdownStyles = `
  width: 100%;
  height: 44px;
  padding: 0 11px;
  color: #585858;
  background: #fff;
  border: 1px solid #dfe3e8;
  border-radius: 4px;
  font-family: Poppins;

  &:focus-visible {
    outline-color: #ed6928;
  }

  &:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const StyledCountry = styled(CountryDropdown)`
  ${dropdownStyles}
`;

export const StyledRegion = styled(RegionDropdown)`
  ${dropdownStyles}
`;

export const StyledButton = styled(AntButton)`
  margin-right: 8px;
  min-height: 44px;
  height: 50px;
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 16px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  gap: 12px;

  ${media.downMobile`
    flex-direction: column;
  `}
`;

export const CancelButton = styled(AntButton)`
  width: 30%;
  min-height: 44px;
  height: 50px;
  color: #000;
  background: #fff;
  border-color: #c8c8c8;
  &:hover {
    background: #ed6928 !important;
    color: #fff !important;
  }

  ${media.downMobile`
    width: 100%;
  `}
`;

export const SaveButton = styled(AntButton)`
  width: 65%;
  min-height: 44px;
  height: 50px;

  ${media.downMobile`
    width: 100%;
  `}
`;

export const MainHeading = styled.h3`
  margin: 0px;
  color: var(--Text2, #000);
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  ${media.downMobile`
    font-size: 20px;
  `}
`;
